import { FunctionComponent } from 'react'
import styled from 'styled-components'

import InvisibleButton from '../../../components/display/InvisibleButton'
import MapPinIcon from '../../../components/icons/MapPin'
import ListIcon from '../../../components/icons/List'

const ViewToggleInner = styled(InvisibleButton)<{ mapOpen: boolean }>`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;

  bottom: 30px;
  left: 50%;
  transform: translate(-50%);
  border-radius: 8px;
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxs']?.['font-size']?.value};
  padding: 8px;
  color: ${({ mapOpen, theme }) =>
    mapOpen
      ? theme?.['-ds-core-400']?.value
      : theme?.['-ds-neutral-100']?.value};
  background-color: ${({ mapOpen, theme }) =>
    mapOpen ? 'white' : theme.brand.jungle};

  overflow: hidden;
  z-index: 5;
  box-shadow:
    0px 1px 6px rgba(0, 0, 0, 0.039),
    0px 5.5px 16px rgba(0, 0, 0, 0.19);

  svg {
    width: 16px;
    height: 14px;
    color: ${({ mapOpen, theme }) => (mapOpen ? theme.brand.jungle : 'white')};
    margin-right: 8px;
  }
`

const ViewToggle: FunctionComponent<{
  mapOpen: boolean
  onClick: () => any
}> = ({ mapOpen, onClick }) => {
  return (
    <ViewToggleInner onClick={onClick} mapOpen={mapOpen}>
      {mapOpen ? (
        <>
          <ListIcon />
          List
        </>
      ) : (
        <>
          <MapPinIcon />
          Map
        </>
      )}
    </ViewToggleInner>
  )
}

export default ViewToggle
